var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "v-sheet",
        {
          staticClass: "px-2",
          attrs: { color: _vm.color + " lighten-2", elevation: "2" }
        },
        [
          _c("display-card-head", {
            attrs: {
              date: _vm.date,
              icon: _vm.icon,
              "icon-tooltip": _vm.iconTooltip,
              title: _vm.title
            }
          }),
          _vm._v(" "),
          _c(
            "v-container",
            { staticClass: "pa-0" },
            [
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c(
                    "v-sheet",
                    {
                      staticClass: "pa-1",
                      attrs: { color: "text-background", width: "100%" }
                    },
                    [
                      _vm.subtitle
                        ? _c("p", { staticClass: "font-weight-black" }, [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.subtitle) +
                                "\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.subsubtitle
                        ? _c("u", [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.subsubtitle) +
                                "\n          "
                            )
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { "white-space": "pre-wrap" } },
                        [_vm._v(_vm._s(_vm.resume))]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-list-item",
                { staticClass: "grow", attrs: { dense: "" } },
                [
                  _c(
                    "v-list-item-avatar",
                    { attrs: { size: "25" } },
                    [_c("v-icon", [_vm._v("person")])],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", [
                        _c(
                          "p",
                          {
                            staticClass:
                              "text-break ma-0 font-italic font-weight-medium"
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.author) +
                                "\n            "
                            )
                          ]
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-row",
                    { attrs: { align: "center", justify: "end" } },
                    [
                      _vm._t("actions"),
                      _vm._v(" "),
                      _c(
                        "v-tooltip",
                        {
                          attrs: { bottom: "" },
                          scopedSlots: _vm._u([
                            {
                              key: "activator",
                              fn: function({ on }) {
                                return [
                                  _vm.number_of_children > 0
                                    ? _c(
                                        "v-btn",
                                        _vm._g(
                                          {
                                            staticClass: "mr-5",
                                            attrs: { icon: "" },
                                            on: { click: _vm.handleShowMore }
                                          },
                                          on
                                        ),
                                        [
                                          _c(
                                            "v-badge",
                                            {
                                              attrs: {
                                                overlap: "",
                                                color: "secondary",
                                                content: _vm.number_of_children
                                              }
                                            },
                                            [
                                              _vm.showChild
                                                ? _c(
                                                    "v-icon",
                                                    { attrs: { large: "" } },
                                                    [_vm._v("expand_less")]
                                                  )
                                                : _c(
                                                    "v-icon",
                                                    { attrs: { large: "" } },
                                                    [_vm._v("expand_more")]
                                                  )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              }
                            }
                          ])
                        },
                        [
                          _vm._v(" "),
                          _c("span", { staticClass: "ma-1" }, [
                            _vm._v("Afficher les évènements suivants")
                          ])
                        ]
                      )
                    ],
                    2
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-expand-transition", [
        _vm.showChild
          ? _c(
              "div",
              _vm._l(_vm.children, function(child) {
                return _c("event-card", {
                  key: child.id,
                  staticClass: "my-1 mx-10 darken-2",
                  attrs: {
                    title: child.payload_type_description,
                    icon: _vm.icon,
                    color: _vm.color,
                    resume: child.resume,
                    date: child.entry_datetime,
                    author: `${child.author_name} (${child.author_type})`
                  }
                })
              }),
              1
            )
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }